import { Typography } from "@material-ui/core";
import { styled } from "@material-ui/core/styles";
import PropTypes from "prop-types";
import * as React from "react";
import { copyToClipboard } from "../util";

const FEEDBACK_DURATION = 2000;

const CopyLink = React.memo(function CopyLink({ text, url, variant, color }) {
  const timeoutRef = React.useRef(null);
  const [copied, setCopied] = React.useState(false);

  const handleClick = React.useCallback(async () => {
    const success = await copyToClipboard(url);

    if (!success) {
      return;
    }

    setCopied(true);
    clearTimeout(timeoutRef.current);
    timeoutRef.current = setTimeout(() => {
      setCopied(false);
    }, FEEDBACK_DURATION);
  }, [url]);

  React.useEffect(
    () => () => {
      clearTimeout(timeoutRef.current);
    },
    [],
  );

  return (
    <StyledButton
      type="button"
      onClick={handleClick}
      aria-label={copied ? "Link copied" : `Copy ${text} to clipboard`}
    >
      <Typography variant={variant} color={color} component="span">
        {copied ? "Copied!" : text}
      </Typography>
    </StyledButton>
  );
});

CopyLink.propTypes = {
  text: PropTypes.string.isRequired,
  url: PropTypes.string.isRequired,
  variant: PropTypes.string,
  color: PropTypes.string,
};

CopyLink.defaultProps = {
  variant: "caption",
  color: "textSecondary",
};

const StyledButton = styled("button")(({ theme }) => ({
  all: "unset",
  cursor: "pointer",
  display: "inline",
  borderRadius: theme.spacing(0.5),
  "&:hover span": {
    color: theme.palette.secondary.main,
    textDecoration: "underline",
  },
  "&:focus-visible": {
    outline: `2px solid ${theme.palette.secondary.main}`,
    outlineOffset: 2,
  },
}));

export default CopyLink;
